import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
import { IDNameViewModel } from 'TypeGen/id-name-view-model';
import { FreightDetail } from 'TypeGen/Order/Load/freight-detail';
import { RequestFreightDetail } from 'TypeGen/Order/Load/request-freight-detail';
import PiecesInput from './PiecesInput';
import WeightInput from './WeightInput';
import DimsInput from './DimsInput';

type Props = {
  piecesUnitOfMeasure: IDNameViewModel[];
  weightUnitOfMeasure: IDNameViewModel[];
  dimsUnitOfMeasure: IDNameViewModel[];
  data: FreightDetail;
  request: RequestFreightDetail;
  updateRequest: (request: Partial<RequestFreightDetail>) => void;
}

const LoadFreight = ({ data, request, updateRequest, ...props }: Props) => {
  return <>
    <PiecesInput
      request={request}
      data={data}
      updateRequest={updateRequest}
      piecesUnitOfMeasure={props.piecesUnitOfMeasure}
    />

    <WeightInput
      request={request}
      data={data}
      updateRequest={updateRequest}
      weightUnitOfMeasure={props.weightUnitOfMeasure}
    />

    <Input
      required
      label='Bill of Lading'
      value={request.BillOfLading}
      onChange={(e) => updateRequest({ BillOfLading: e.value })}
      style={{ width: "100%" }}
    />

    <DimsInput
      dimsUnitOfMeasure={props.dimsUnitOfMeasure}
      data={data}
      request={request}
      updateRequest={updateRequest}
    />

    <Input
      label='In Bond No.'
      value={request.InBondNumber}
      onChange={(e) => updateRequest({ InBondNumber: e.value })}
      style={{ width: "100%" }}
    />

    <NumericTextBox
      min={0}
      label='Freight Value'
      spinners={false}
      format="c2"
      value={request.FreightValue}
      onChange={(e) => updateRequest({ FreightValue: e.value })}
      width="100%"
    />
  </>
}
export default LoadFreight;
